var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-add"},[_c('div',{staticClass:"add-title"},[_vm._v("编辑问卷")]),_c('QuestionForm',{attrs:{"defaultForm":_vm.questionnaireForm,"submitApi":_vm.api}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }